module.exports = __webpack_public_path__ + "static/media/aFichier 1.3f735828.svg";